export default "__VITE_ASSET__DSJPvw9d__"